import { gql } from '@apollo/client';
export const StatFeatureCareRules = gql `
    fragment StatFeatureCareRules on CareRulesFeatureSettings {
        canToggle
        isEnabled
    }
`;
